// extracted by mini-css-extract-plugin
export var skeletonLoader = "skeleton-loader-module--skeletonLoader--24ab8";
export var skeletonPulse = "skeleton-loader-module--skeletonPulse--d4e69";